import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import Box from '@material-ui/core/Box'
import SaveAltIcon from '@material-ui/icons/SaveAlt'
import InstallForm from 'components/install/InstallForm'

const useStyles = makeStyles(theme => ({
	paper: {
		padding: theme.spacing(3),
		[theme.breakpoints.up('md')]: {
			marginTop: theme.spacing(6),
			marginBottom: theme.spacing(6),
		},
		[theme.breakpoints.down('sm')]: {
			marginTop: theme.spacing(2),
			marginBottom: theme.spacing(2),
		},
	},
	avatar: {
		background: 'linear-gradient(135deg, #FAB2FF 10%, #1904E5 100%)',
		margin: `0 auto ${theme.spacing(2)}px`,
	},
}))

function Install(props) {
	const classes = useStyles()

	useEffect(() => {
		document.title = '웹박수 | 설치'
	}, [])

	return (
		<Container maxWidth="sm">
			<Paper className={classes.paper}>
				<Box textAlign="center">
					<Avatar className={classes.avatar}>
						<SaveAltIcon />
					</Avatar>
					<Typography gutterBottom variant="h6" component="h2">
						웹박수 설치
					</Typography>
				</Box>
				<InstallForm />
			</Paper>
		</Container>
	)
}

export default Install
